import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "17",
  fill: "none",
  viewBox: "0 0 14 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.992 16.5c.14 0 .352-.055.555-.164 4.484-2.445 6.047-3.57 6.047-6.414V4.008c0-.922-.36-1.25-1.133-1.578-.867-.368-3.797-1.399-4.656-1.68a2.6 2.6 0 0 0-.813-.14c-.258 0-.554.07-.812.14-.852.234-3.782 1.32-4.649 1.68-.773.32-1.133.656-1.133 1.578v5.914c0 2.844 1.563 3.96 6.047 6.414.203.11.414.164.547.164m0-1.64c-.11 0-.226-.04-.445-.18-3.578-2.172-4.688-2.766-4.688-5.055V4.258c0-.274.063-.383.274-.469 1.156-.469 3.406-1.21 4.453-1.625a1.2 1.2 0 0 1 .406-.086c.117 0 .235.024.406.086 1.055.414 3.282 1.203 4.454 1.625.218.078.273.195.273.469v5.367c0 2.305-1.148 2.93-4.68 5.055-.226.14-.336.18-.453.18M3.797 8.632c0 .195.164.344.367.344h2.422l-1.29 3.453c-.187.492.345.773.673.375l3.976-4.953a.48.48 0 0 0 .133-.305c0-.203-.164-.344-.367-.344H7.289L8.58 3.75c.187-.5-.345-.773-.673-.375L3.93 8.328a.46.46 0 0 0-.133.305"
    }, null, -1)
  ])))
}
export default { render: render }